/*
 * @Author: hippo
 * @Date: 2023-04-08 23:12:42
 * @LastEditors: hippo
 * @LastEditTime: 2023-12-08 15:41:21
 * @FilePath: /subang-console/src/containers/finances/constants.js
 * @Description: 
 * 
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved. 
 */
export const transactionTypes = {
  'baozheng/charge': '保证金充值',
  'balance/adjust': '调整余额',
  'balance/deduct': '工单结算【余额】',
  //'balance/deduction': '上调，从余额扣除【余额】',
  //'balance/refund': '下调，退入余额【余额】', // 暂时不需要，隐藏

  'credit/adjust': '调整信用额度',
  'credit/deduct': '工单结算【额度】',
  'credit/refund': '退款，恢复额度', // 暂时不需要，隐藏

  'withdraw': '师傅提现',
  'payment': '在线支付',
  //'refund': '退款', // 暂时不需要，隐藏

  'worker/order_settlement': '师傅工单结算',
  'agent/settlement': '推广员结算',
  'agent/to_cash': '推广员提现',
  'tenant/balance_recharge': '企业账户充值',
  'tenant/credit_recharge': '企业账户充值【额度】',
  'balance/tenant/refund': '下调订单价格',
  'balance/worker/deduction': '下调师傅价格',
  'balance/tenant/deduction': '上调订单价格',
  'balance/worker/refund': '上调师傅价格',
  'tenant_coupon/deduct': '代金券抵扣',
  'worker_coupon/refund': '奖金券奖励',
  'credit/tenant/deduction': '上调商家价格【额度】',
  'credit/tenant/refund': '下调商家价格【额度】',
  'claim/add': '增加索赔金额', //增加索赔金额
  'claim/desc': '扣除索赔金额', //扣除索赔金额
  'baozheng/charge': '充值保证金', //充值保证金
  'baozheng/withdraw': '保证金取出', //保证金取出
  'baozheng/desc': '手动扣除保证金', //手动扣除保证金
  'retail/order': '散户下单', //散户下单
  'retail/order/changeWorker': '散户更换师傅', //散户更换师傅
  'balance/retail/add': '散户新增费用',//散户新增费用
  'balance/retail/desc': '散户下调费用',//散户下调费用
  'balance/worker/add': '师傅新增费用',//师傅新增费用
  'balance/retail/confirm': '散户支付确认',//散户支付确认
  'retail/order/refund': '散户退款',//散户退款
}

export const payMethodTypes = {
  1: ' (额度支付)',
  2: ' (余额支付)',
  3: ' (在线支付)'
}
// 精简 transactionTypes ，只显示企业相关类型
export const tenantsTransactionTypes = {
  'balance/deduct': '工单结算【余额】',
  'credit/deduct': '工单结算【额度】',
  'balance/adjust': '调整余额',
  'credit/adjust': '调整信用额度',
  'tenant/balance_recharge': '企业账户充值',
  'tenant/credit_recharge': '企业账户充值【额度】',
  'balance/refund': '下调，退入余额【余额】',
  'balance/deduction': '上调，从余额扣除【余额】',
  'balance/tenant/refund': '商家余额增加',
  'balance/tenant/deduction': '商家余额减少',
  'credit/tenant/deduction': '上调商家价格【额度】',
  'credit/tenant/refund': '下调商家价格【额度】',
  'tenant_coupon/deduct': '代金券抵扣',
  'worker/order_settlement': '工单收入',
  'claim/add': '增加索赔金额', //增加索赔金额
  'claim/desc': '扣除索赔金额', //扣除索赔金额
}


export const flowTypes = {
  'baozheng/charge': '保证金充值',
  'income/order': '工单收入', // income 工单收入, 结算时计入
  'expense/worker/order_settlement': '结算师傅工费', // expense 支付师傅费用
  'expense/agent/settlement': '推广员结算', // 推广员结算
  //'expense/withdraw': '退款', // 退款
  //'income/deduction': '扣款', // 扣款
  'balance_adjust': '调整余额(不包含充值)', // 余额调整(不包含充值)，包含 income/expense
  'income/worker_fee/down': '下调师傅价格',
  'expense/worker_fee/raise': '上调师傅价格',
  'expense/tenant_fee/down': '下调商家价格',
  'income/tenant_fee/raise': '上调商家价格'
}
